export default "/images/flutter.svg?f0ee577433160fa19746210d554c6c0d";